import {
	Div,
	LI,
	Number as NumberInput,
	reactive,
} from 'alkali'
import {
	default as AvailableQuestions,
	questionsSource,
	ShortcutQuestions,
} from 'components/entry/AvailableQuestions'
import app from '../../app/app'
import './AvailableQuestionsPane.scss'
import { AccordionHeader, readonlyUser } from 'pages/Entry'

export const shortcutsTab = reactive().to(
	() =>
		localStorage.getItem('available-question-tab') ||
		questionsSource.to((questions) => {
			if (questions.favorites.length > 0) return 'favorites'
			if (questions.recent.length > 0) return 'recent'
			return 'examples'
		}),
	(tab) => {
		localStorage.setItem('available-question-tab', tab)
	}
)
export default class AvailableQuestionsPane extends LI('.available-questions-pane', {
	classes: { 'can-edit-concepts': app.authdUser },
	onfocusin() {
		this.classList.add('has-focus')
	},
	onfocusout() {
		this.classList.remove('has-focus')
	},
}) {
	created(properties) {
		properties.content = [
			AccordionHeader('shortcuts'),
			Div(`.available-questions.section-content`, [
				ShortcutQuestions('.recent-questions', {
					display: shortcutsTab.to((tab) => tab == 'recent'),
					type: 'recent',
				}),
				ShortcutQuestions('.favorite-questions', {
					display: shortcutsTab.to((tab) => tab == 'favorites'),
					type: 'favorites',
				}),
				ShortcutQuestions('.collections-questions', {
					display: shortcutsTab.to((tab) => tab == 'collections'),
					type: 'collections',
				}),
				ShortcutQuestions('.screening-questions', {
					display: shortcutsTab.to((tab) => tab == 'screenings'),
					type: 'screenings',
				}),
				ShortcutQuestions('.example-questions', {
					display: shortcutsTab.to((tab) => tab == 'examples'),
					type: 'examples',
				}),
			], {
				display: shortcutsTab.to((tab) => tab !== 'null'),
			})
		]
	}
}